import { useEffect } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoPlayerBlack from '@/components/UI/svg/DeltaPro/Icon/EFVideoPlayerBlack';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { youtubeMap } from '@/constants/delta2max';

export default function A() {
    const { useLang, useState, gtm, useRouter } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const { locale } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 - Not Just a Battery',
            position,
            __btn_id1: 'd2x-detail-A',
            __btn_id2: t('sec1_btn'),
        });
        setShowEFVideoModal(true);
    };

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [['.d2x-detail-A .ani-box', { y: 0 }, { y: 150 }, 1]],
            // asyncTimeLine: [0, 1.8, 1.8, 3, 3.3, 3.6],
            asyncTimeLine: [0],
            triggerElement: '.d2x-detail-A',
            triggerHook: 0,
            // offset: -60,
            duration: '100%',
        });
    }, []);
    return (
        <div
            className={`d2x-detail-A ${css.d2xDetailA} GtmModuleData-section`}
            id="d2x-detail-A"
            data-section-id={'d2x-detail-A'}
            data-section-title={t('sec1_title')}
        >
            <div className="top-box">
                <p className="top-text">{t('sec1_slogan')}</p>
            </div>
            <div className="sec1">
                <div className="ani-box">
                    <div className="img-box">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/detail/pc/KV.webp')}
                            src={require('@publicLocal/delta2max/detail/pc/KV.jpg')}
                            alt={t('sec1_title')}
                            aria-label={t('sec1_title')}
                        />
                    </div>
                </div>
                <div className="text-box">
                    <p className="desc">{t('sec1_desc')}</p>
                    <p className="title">{t('sec1_title')}</p>
                    <div className="watch-video-btn GtmModuleData-btn-text" onClick={() => playerVideo(t('sec1_title'))}>
                        {t('sec1_btn')}
                        <EFVideoPlayerBlack className="icon" />
                    </div>
                </div>
                <div className="img-box2">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/detail/pc/red_dot.webp')}
                        src={require('@publicLocal/delta2max/detail/pc/red_dot.png')}
                        alt={t('sec1_title')}
                        aria-label={t('sec1_title')}
                    />
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={youtubeMap[locale] || youtubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
